import React, { useEffect, useState, createElement } from 'react';
import { HeroSection } from '../components/stingfit/HeroSection';
import { MiniBundles } from '../components/stingfit/MiniBundles';
import { SocialProofSeal } from '../components/stingfit/SocialProofSeal';
import { ProblemEscalation } from '../components/stingfit/ProblemEscalation';
import { MechanismSection } from '../components/stingfit/MechanismSection';
import { DoctorEndorsementSection } from '../components/stingfit/DoctorEndorsementSection';
import { BenefitsTimeline } from '../components/stingfit/BenefitsTimeline';
import { HowItWorks } from '../components/stingfit/HowItWorks';
import { ProductShowcase } from '../components/stingfit/ProductShowcase';
import { EbookSection } from '../components/stingfit/EbookSection';
import { ProblemReframe } from '../components/stingfit/ProblemReframe';
import { TestimonialGrid } from '../components/stingfit/TestimonialGrid';
import { BeforeAfterSection } from '../components/stingfit/BeforeAfterSection';
import { ResultsCollageSection } from '../components/stingfit/ResultsCollageSection';
import { OfferStack } from '../components/stingfit/OfferStack';
import { PricingBundles } from '../components/stingfit/PricingBundles';
import { FAQAccordion } from '../components/stingfit/FAQAccordion';
import { Button } from '../components/stingfit/ui/Button';
import { ShieldCheck, Truck, CreditCard, Zap } from 'lucide-react';
import { ScienceCallout, WhyItWorks, RoutineStrip, ComparisonTable, ForWhomBanner, PullQuote, IngredientsSpotlight, SocialTicker } from '../components/stingfit/BrandStrips';
export function StingFitLanding() {
  const [activeModal, setActiveModal] = useState<'terminos' | 'privacidad' | 'contacto' | null>(null);
  const [stock, setStock] = useState(23);
  useEffect(() => {
    // Meta Pixel
    const pixelId = '965958182359799';
    if (!(window as any).fbq) {
      const fbq: any = function () {
        fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
      };
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      (window as any).fbq = fbq;
      (window as any)._fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    ;
    (window as any).fbq('init', pixelId);
    (window as any).fbq('track', 'PageView');
    const interval = setInterval(() => {
      setStock(s => {
        if (s <= 7) return s;
        return Math.random() > 0.7 ? s - 1 : s;
      });
    }, 45000);
    return () => clearInterval(interval);
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-1289">
      {/* Modals */}
      {activeModal && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-1290">
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-1291" />
          <div className="relative bg-white rounded-2xl shadow-2xl max-w-lg w-full max-h-[80vh] overflow-y-auto p-8 z-10" data-id="element-1292">
            <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 text-2xl font-bold leading-none" data-id="element-1293">
              ×
            </button>

            {activeModal === 'terminos' && <>
                <h2 className="text-2xl font-black text-[#2D5016] mb-4" data-id="element-1294">
                  Términos y Condiciones
                </h2>
                <div className="text-sm text-gray-600 space-y-3 leading-relaxed" data-id="element-1295">
                  <p data-id="element-1296">
                    Al realizar una compra en StingFit México, aceptas los
                    siguientes términos y condiciones.
                  </p>
                  <p data-id="element-1297">
                    <strong data-id="element-1298">Productos:</strong> Todos los productos son
                    suplementos alimenticios. Los resultados pueden variar según
                    cada persona.
                  </p>
                  <p data-id="element-1299">
                    <strong data-id="element-1300">Pagos:</strong> Los pagos se procesan de forma
                    segura. Aceptamos las principales tarjetas de crédito,
                    débito, OXXO y pago contra entrega.
                  </p>
                  <p data-id="element-1301">
                    <strong data-id="element-1302">Envíos:</strong> Los pedidos se procesan en 1-2 días
                    hábiles. El tiempo de entrega estimado es de 3-10 días
                    hábiles en la República Mexicana.
                  </p>
                  <p data-id="element-1303">
                    <strong data-id="element-1304">Garantía:</strong> Ofrecemos una garantía de
                    devolución de 90 días. Si no estás satisfecho, te devolvemos
                    el dinero sin preguntas.
                  </p>
                  <p data-id="element-1305">
                    <strong data-id="element-1306">Uso:</strong> Los productos deben usarse según las
                    instrucciones del fabricante. No reemplaza el consejo médico
                    profesional.
                  </p>
                </div>
              </>}

            {activeModal === 'privacidad' && <>
                <h2 className="text-2xl font-black text-[#2D5016] mb-4" data-id="element-1307">
                  Política de Privacidad
                </h2>
                <div className="text-sm text-gray-600 space-y-3 leading-relaxed" data-id="element-1308">
                  <p data-id="element-1309">
                    En StingFit México nos comprometemos a proteger tu
                    privacidad y tus datos personales.
                  </p>
                  <p data-id="element-1310">
                    <strong data-id="element-1311">Datos que recopilamos:</strong> Nombre, dirección de
                    correo electrónico, dirección de envío y datos de pago
                    necesarios para procesar tu pedido.
                  </p>
                  <p data-id="element-1312">
                    <strong data-id="element-1313">Uso de datos:</strong> Utilizamos tus datos
                    únicamente para procesar pedidos, enviarte información sobre
                    tu compra y mejorar nuestros servicios.
                  </p>
                  <p data-id="element-1314">
                    <strong data-id="element-1315">Compartición de datos:</strong> No vendemos ni
                    compartimos tus datos personales con terceros, salvo con
                    proveedores de servicios necesarios para completar tu
                    pedido.
                  </p>
                  <p data-id="element-1316">
                    <strong data-id="element-1317">Cookies:</strong> Utilizamos cookies para mejorar tu
                    experiencia de navegación. Puedes desactivarlas en la
                    configuración de tu navegador.
                  </p>
                  <p data-id="element-1318">
                    <strong data-id="element-1319">Tus derechos:</strong> Tienes derecho a acceder,
                    rectificar o eliminar tus datos personales. Contáctanos para
                    ejercer estos derechos.
                  </p>
                  <p data-id="element-1320">
                    <strong data-id="element-1321">Ley de Protección de Datos:</strong> Cumplimos con
                    la Ley Federal de Protección de Datos Personales en Posesión
                    de los Particulares (LFPDPPP) de México.
                  </p>
                </div>
              </>}

            {activeModal === 'contacto' && <>
                <h2 className="text-2xl font-black text-[#2D5016] mb-4" data-id="element-1322">
                  Contacto
                </h2>
                <div className="text-sm text-gray-600 space-y-4 leading-relaxed" data-id="element-1323">
                  <p data-id="element-1324">¿Tienes alguna pregunta? Estamos aquí para ayudarte.</p>
                  <div className="bg-[#D4AF37]/10 rounded-xl p-4 space-y-2" data-id="element-1325">
                    <p data-id="element-1326">
                      <strong className="text-[#2D5016]" data-id="element-1327">📧 Email:</strong>{' '}
                      contact@glowliftessencemx.com
                    </p>
                    <p data-id="element-1328">
                      <strong className="text-[#2D5016]" data-id="element-1329">🕐 Horario:</strong>{' '}
                      Lunes a Viernes, 9:00 – 18:00 (CST)
                    </p>
                    <p data-id="element-1330">
                      <strong className="text-[#2D5016]" data-id="element-1331">📦 Pedidos:</strong>{' '}
                      Respuesta en menos de 24 horas hábiles
                    </p>
                  </div>
                  <p data-id="element-1332">
                    Para devoluciones o cambios, incluye tu número de pedido en
                    el asunto del correo. Procesamos todas las solicitudes de
                    garantía en un plazo de 2-3 días hábiles.
                  </p>
                </div>
              </>}

            <button onClick={() => setActiveModal(null)} className="mt-6 w-full bg-[#2D5016] text-white font-bold py-3 rounded-xl hover:bg-[#3a6a1e] transition-colors" data-id="element-1333">
              Cerrar
            </button>
          </div>
        </div>}

      {/* TOP URGENCY BAR */}
      <div className="bg-gradient-to-r from-red-700 via-red-600 to-red-700 text-white py-2.5 px-4 text-center text-sm font-bold relative overflow-hidden" data-id="element-1334">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMSIgZmlsbD0id2hpdGUiIG9wYWNpdHk9IjAuMSIvPjwvc3ZnPg==')] opacity-30" data-id="element-1335"></div>
        <span className="relative flex items-center justify-center gap-2 flex-wrap" data-id="element-1336">
          <span className="animate-pulse" data-id="element-1337">⚡</span>
          <span data-id="element-1338">OFERTA FLASH: Envío GRATIS + Descuento Especial Activo</span>
          <span className="bg-white/20 px-2 py-0.5 rounded-full text-xs" data-id="element-1339">
            Solo quedan{' '}
            <span className="font-black text-yellow-300" data-id="element-1340">{stock} unidades</span>
          </span>
          <span className="animate-pulse" data-id="element-1341">⚡</span>
        </span>
      </div>

      <SocialTicker data-id="element-1342" />

      {/* Sticky Header for Mobile/Desktop */}
      <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100 shadow-sm py-3" data-id="element-1343">
        <div className="container mx-auto px-4 flex justify-between items-center max-w-6xl" data-id="element-1344">
          <div className="text-2xl font-black text-[#2D5016] tracking-tighter" data-id="element-1345">
            STING<span className="text-[#D4AF37]" data-id="element-1346">FIT</span>
          </div>
          <div className="flex items-center gap-3" data-id="element-1347">
            <div className="hidden sm:flex items-center gap-1.5 text-xs text-green-700 font-semibold bg-green-50 px-3 py-1.5 rounded-full border border-green-200" data-id="element-1348">
              <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-1349"></span>
              {stock} unidades restantes
            </div>
            <Button size="sm" onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-1350">
              🛒 Comprar Ahora
            </Button>
          </div>
        </div>
      </header>

      <main data-id="element-1351">
        <HeroSection data-id="element-1352" />
        <MiniBundles data-id="element-1353" />
        <SocialProofSeal data-id="element-1354" />
        <ForWhomBanner data-id="element-1355" />
        <ProblemEscalation data-id="element-1356" />
        <ScienceCallout data-id="element-1357" />
        <IngredientsSpotlight data-id="element-1358" />
        <MechanismSection data-id="element-1359" />
        <DoctorEndorsementSection data-id="element-1360" />
        <WhyItWorks data-id="element-1361" />
        <BenefitsTimeline data-id="element-1362" />
        <RoutineStrip data-id="element-1363" />
        <HowItWorks data-id="element-1364" />
        <ProductShowcase data-id="element-1365" />
        <EbookSection data-id="element-1366" />
        <ProblemReframe data-id="element-1367" />
        <PullQuote data-id="element-1368" />
        <ComparisonTable data-id="element-1369" />
        <TestimonialGrid data-id="element-1370" />
        <BeforeAfterSection data-id="element-1371" />
        <ResultsCollageSection data-id="element-1372" />
        <OfferStack data-id="element-1373" />
        <PricingBundles data-id="element-1374" />
        <FAQAccordion data-id="element-1375" />
      </main>

      {/* Sticky Mobile Bottom CTA */}
      <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-white border-t-2 border-[#D4AF37] shadow-2xl px-4 py-3" data-id="element-1376">
        <div className="flex items-center gap-3" data-id="element-1377">
          <div className="flex-1 min-w-0" data-id="element-1378">
            <p className="text-xs text-gray-500 leading-tight" data-id="element-1379">Pack 3 Meses</p>
            <div className="flex items-baseline gap-1.5" data-id="element-1380">
              <span className="text-lg font-black text-[#2D5016]" data-id="element-1381">
                $1,199 MXN
              </span>
              <span className="text-xs text-gray-400 line-through" data-id="element-1382">
                $3,600 MXN
              </span>
              <span className="text-xs font-bold text-green-600 bg-green-50 px-1.5 py-0.5 rounded" data-id="element-1383">
                -67%
              </span>
            </div>
          </div>
          <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="flex-shrink-0 bg-[#D4AF37] text-white font-black text-sm px-5 py-3 rounded-full shadow-lg active:scale-95 transition-transform uppercase tracking-wide animate-pulse" data-id="element-1384">
            ¡QUIERO ESTO! →
          </button>
        </div>
      </div>

      <footer className="bg-[#2D5016] text-white py-12 border-t border-white/10 pb-24 md:pb-12" data-id="element-1385">
        <div className="container mx-auto px-4 text-center max-w-6xl" data-id="element-1386">
          <div className="text-2xl font-black tracking-tighter mb-4" data-id="element-1387">
            STING<span className="text-[#D4AF37]" data-id="element-1388">FIT</span>
          </div>
          {/* Payment icons */}
          <div className="flex justify-center items-center gap-3 mb-6 flex-wrap" data-id="element-1389">
            {['VISA', 'MC', 'AMEX', 'PAYPAL', 'OXXO'].map(p => <span key={p} className="bg-white/10 text-white/70 text-xs font-bold px-3 py-1 rounded border border-white/20" data-id="element-1390">
                {p}
              </span>)}
            <span className="bg-white/10 text-white/70 text-xs font-bold px-3 py-1 rounded border border-white/20 flex items-center gap-1" data-id="element-1391">
              🔒 256-bit SSL
            </span>
          </div>
          <div className="flex justify-center gap-6 mb-8 text-sm text-green-100" data-id="element-1392">
            <button onClick={() => setActiveModal('terminos')} className="hover:text-white transition-colors cursor-pointer" data-id="element-1393">
              Términos
            </button>
            <button onClick={() => setActiveModal('privacidad')} className="hover:text-white transition-colors cursor-pointer" data-id="element-1394">
              Privacidad
            </button>
            <button onClick={() => setActiveModal('contacto')} className="hover:text-white transition-colors cursor-pointer" data-id="element-1395">
              Contacto
            </button>
          </div>
          <p className="text-xs text-green-200/50 max-w-2xl mx-auto" data-id="element-1396">
            © 2026 StingFit México. Todos los derechos reservados. Este sitio
            no es parte del sitio web de Facebook o Facebook Inc. Además, este
            sitio no está respaldado por Facebook de ninguna manera. FACEBOOK es
            una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}